import { render } from "./edit-note.vue?vue&type=template&id=0600c2df"
import script from "./edit-note.vue?vue&type=script&lang=js"
export * from "./edit-note.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__